/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

export interface MessagesState {
  messages: {
    data: {
      title: string;
      message: string;
      type: MessagesType;
      centered?: boolean | null;
    };
  };
}

export interface MessagesPayload {
  title: string;
  message: string;
  type: MessagesType;
  centered?: boolean | null;
}

export enum MessagesType {
  DIALOG = "messages_dialog",
  SNACK = "messages_snack",
}
